import * as React from 'react'
import styled from 'styled-components'
import { SPACE } from '../../styles/constants'
import { getBreakpoint } from '../../styles/getBreakpoint'

import { Icon } from '../Icon'

export const ChannelList: React.SFC = () => (
  <Wrapper>
    <Item href="https://facebook.com/steadio.hq/" target="_blank" rel="noopener">
      <Icon icon="facebook" size={24} />
    </Item>
    <Item href="https://twitter.com/SteadioHQ/" target="_blank" rel="noopener">
      <Icon icon="twitter" size={24} />
    </Item>
  </Wrapper>
)

const Wrapper = styled.div`
  display: inline-block;
  line-height: 0;
  ${getBreakpoint(0)`
		${SPACE.inline.s};
	`};
`
const Item = styled.a`
  display: inline-block;
  line-height: 0;
  ${SPACE.inline.xs};
`



// WEBPACK FOOTER //
// ./src/components/ChannelList/index.tsx